/* __next_internal_client_entry_do_not_use__ SDUICarouselButton auto */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { IButtonElement } from "@faire/web-api--source/indigofair/data/IButtonElement";
import { IFaireIcon } from "@faire/web-api--source/indigofair/data/IFaireIcon";
import React from "react";
import { SDUIButtonRenderer } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/Button/SDUIButtonRenderer";
export var SDUICarouselButton = function(param) {
    var button = param.button, loggingData = param.loggingData;
    var isMobile = useViewport().isMobile;
    var buttonElement = getButtonElement(button, isMobile);
    return /*#__PURE__*/ _jsx(SDUIButtonRenderer, {
        buttonElement: buttonElement,
        loggingData: loggingData,
        fireLegacyOnClickEvent: true
    });
};
// TODO: https://fairewholesale.atlassian.net/browse/FD-208064
// Proper solution to handle responsive values for mobile
// Temporarily adding this to have arrow button in place of carousel CTA on mobile
var getButtonElement = function(ctaButton, isMobile) {
    if (isMobile) {
        return IButtonElement.build(_object_spread_props(_object_spread({}, ctaButton), {
            icon: IFaireIcon.build({
                type: IFaireIcon.Type.ARROW
            }),
            variant: "TERTIARY"
        }));
    }
    return ctaButton;
};
